import { render, staticRenderFns } from "./datatableDisponibilita.vue?vue&type=template&id=63787228"
import script from "./datatableDisponibilita.vue?vue&type=script&lang=js"
export * from "./datatableDisponibilita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports